import { normalizeId } from './ids';

/**
 * TOLD WHEN FLAGGED (PR 10e; the 10e contract): when the malware scan flags
 * a file, keepr sends ONE in-app notification through the inbox to the
 * uploader and the collection's managers, once per file — never an email:
 *
 *   kind: 'file-flagged', data: { fileId, itemId, collectionId }
 *
 * The server writes the words; this module says the same when a row arrives
 * without them, and gives the row its door to the item. The words never
 * repeat the file's name or the item's title (text the person typed, and a
 * title this build cannot check is still theirs to see) — the item says
 * which file when it opens.
 */

export const FILE_FLAGGED_NOTICE_KIND = 'file-flagged';

export const isFileFlaggedNotice = notification => notification?.kind === FILE_FLAGGED_NOTICE_KIND;

const dataOf = notification => (notification?.data && typeof notification.data === 'object' ? notification.data : {});

export const FILE_FLAGGED_NOTICE_TITLE = 'A file was flagged by the malware scan';

/** The collection the notice is about: its data's, else the row's. */
export const fileFlaggedCollectionId = notification => (
	normalizeId(dataOf(notification).collectionId) || normalizeId(notification?.collection_id) || null
);

/** The item's door, or null without both ids. */
export function fileFlaggedPath(notification) {
	const collectionId = fileFlaggedCollectionId(notification);
	const itemId = normalizeId(dataOf(notification).itemId);
	return collectionId && itemId
		? `/collections/${encodeURIComponent(collectionId)}/items/${encodeURIComponent(itemId)}`
		: null;
}

/** The notice's sentences, with the collection's name when known. */
export function fileFlaggedText(notification, { collectionName = '' } = {}) {
	const where = collectionName ? `an item in ${collectionName}` : 'one of your items';
	// The server's own sentences (keepr-api utils/fileScanSweep.js), so a row
	// reads the same whichever side wrote it.
	return `A file on ${where} was flagged by the malware scan. Nobody can download it from a public link. `
		+ 'People signed in are warned before they download it.';
}
